'use client';

import FaqList, { type FaqListProps } from '@/features/home/components/fag-list';
// import AboutUs, { type AboutUsProps } from '@/features/home/components/about-us';
import Image from 'next/image';
import usdtImg from '@/features/home/images/usdt.png';
import discordImg from '@/features/home/images/icons/discord.png';
import facebookImg from '@/features/home/images/icons/facebook.png';
import telegramImg from '@/features/home/images/icons/telegram.png';
import whatsappImg from '@/features/home/images/icons/whatsapp.png';
import tuiteImg from '@/features/home/images/icons/tuite.png';
import youtubeImg from '@/features/home/images/icons/youtube.png';
import instagramImg from '@/features/home/images/icons/instagram.png';
import kwaiImg from '@/features/home/images/icons/kwai.png';
import { Link } from '@/i18n/navigation';
import { useMemo } from 'react';
import { usePathname } from '@/i18n/navigation';
import { useAtomValue } from 'jotai';
import { baseInfoLoadingAtom } from '@/store/base';
import { isRummyActiveAtom } from '@/app/[locale]/(main)/(non-activity)/rummy/store';
import { Env } from '@/libs/env';
import { isInApp, openUrlInBrowser } from '@/libs/comeAppSDK';

interface FooterContentProps {
  faqProps?: FaqListProps;
  className?: string;
}


export default function FooterContent(props: FooterContentProps) {
  const { className } = props;
  const pathname = usePathname();
  const baseInfoLoading = useAtomValue(baseInfoLoadingAtom);
  const isRummyActive = useAtomValue(isRummyActiveAtom);
  const isBrazil = Env.REGION === 'brazil';
  const isNotCome = Env.NEXT_PUBLIC_BRAND !== 'come';

  const currentConfig = useMemo(() => {
    const allItems = isBrazil
      ? [
          { icon: telegramImg, url: 'https://t.me/+PjqiT755gY80ZmJh' },
          { icon: discordImg, url: 'https://discord.gg/zccDJxwddF', hideOnNotCome: true },
          { icon: tuiteImg, url: 'https://x.com/ComecomBR', hideOnNotCome: true },
          { icon: facebookImg, url: 'https://www.facebook.com/profile.php?id=61581986981503', hideOnNotCome: true },
          { icon: youtubeImg, url: 'https://www.youtube.com/@COME_Brasil', hideOnNotCome: true },
          { icon: kwaiImg, url: 'https://www.kwai.com/@ComeBrasil?fid=150001712629309' },
          { icon: instagramImg, url: 'https://www.instagram.com/come.com_india', hideOnNotCome: true },
        ]
      : [
          { icon: telegramImg, url: 'https://t.me/ComeSportsFantasyOfficial' },
          { icon: discordImg, url: 'https://discord.gg/zccDJxwddF' },
          { icon: tuiteImg, url: 'https://x.com/Comecom_IN', hideOnNotCome: true },
          { icon: whatsappImg, url: 'https://whatsapp.com/channel/0029VbB61pxLSmbReGGAMr2I' },
          { icon: facebookImg, url: 'https://www.facebook.com/profile.php?id=61582327307259', hideOnNotCome: true },
          { icon: youtubeImg, url: 'https://www.youtube.com/@Comecom_IN', hideOnNotCome: true },
          { icon: instagramImg, url: 'https://www.instagram.com/come.com_india', hideOnNotCome: true },
        ];
    return isNotCome ? allItems.filter(item => !item.hideOnNotCome) : allItems;
  }, [isBrazil, isNotCome]);

  const showFooterContent = useMemo(() => {
    if (isRummyActive) {
      return false;
    }
    if (pathname.includes('/play')) {
      return false;
    } else if (pathname.includes('/rummy')) {
      return false;
    } else {
      return true;
    }
  }, [pathname, isRummyActive]);

  const handleJumpInApp = (url: string) => {
    openUrlInBrowser(url);
  };
  return (
    <>
      {
        showFooterContent && !baseInfoLoading && (
          <div className={`bg-surface pb-3 mt-[20px] rounded-t-[10px] ${className}`}>
            <FaqList {...props.faqProps} />
            {/* {showAboutUs ? <AboutUs {...props.aboutProps} /> : <div style={{ height: 20 }} />} */}
            <div style={{ height: 20 }} />
            {/* 加密货币图标容器 - 支持横向滚动 */}
            <div className="flex justify-center space-x-4 overflow-x-auto pb-2 scrollbar-hide">
              {currentConfig.map((item, index) => (
                <div
                  onClick={() => {
                    if (isInApp()) {
                      handleJumpInApp(item?.url ?? '');
                    }
                  }}
                  key={index}
                  className="flex items-center justify-center rounded-[8px] w-[32px] h-[32px] bg-[#151924] active:scale-90"
                >
                  {isInApp() ? (
                    <Image src={item?.icon ?? ''} alt='third-party-icon' width={20} height={20} />
                  ) : (
                    <Link href={item?.url ?? ''} target="_blank">
                      <Image src={item?.icon ?? ''} alt='third-party-icon' width={20} height={20} />
                    </Link>
                  )}
                </div>
              ))}
            </div>
            {/* 版权信息暂未启用。启用前需改为 Env.NEXT_PUBLIC_APP_DOMAIN，避免品牌信息硬编码 */}
            {/* <div className="text-tertiary text-center text-[9px] leading-[10px] mt-[30px] font-medium">
              © 2019-2025 {Env.NEXT_PUBLIC_APP_DOMAIN}丨All rights reserved.
            </div> */}
            <div className="flex items-center justify-center text-tertiary font-medium text-xss leading-[10px] mt-[30px] pb-[25px]">
              <Image src={usdtImg} alt='gcb' width={16} height={16} />
              <div className="text-tertiary text-ss leading-[10px] pl-[5px]">
                1&nbsp;USDT = $1.00
              </div>
            </div>
          </div>
        )
      }
    </>
  );
}